module.exports = __webpack_public_path__ + "img/screen4.1f4fbb99.png";